import { CloseOutlined, DownloadOutlined, EditOutlined, SaveOutlined } from '@ant-design/icons';
import { Breadcrumb, Button, Form, Input, message, Tooltip } from 'antd';
import { PageLoader } from 'components/page-loader/page-loader';
import { FormSectionsSeparator } from 'features/users/components/modals/form-sections-separator';
import React, { useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';

import { TransectionApiServices } from '../api/transection-api.service';
import { useUpdateExpoBoothParticipant } from '../use-cases/update-booth-participant';

interface BoothDetailFieldProps {
    label: string;
    value: string | string[];
    editing: boolean;
    customer_id: any;
}
const BoothParticipantDetailsPage = () => {
    const location = useLocation();
    const { id } = useParams();
    const formName = 'add-organizer-form';
    const [validateTrigger, setValidateTrigger] = useState(['onSubmit']);
    const [form] = Form.useForm();
    const [editing, setEditing] = useState<boolean>(false);
    const [oldBooth, setOldBooth] = useState<any>(0);
    const { isLoading, mutate } = useUpdateExpoBoothParticipant();
    const [participateDetails, setparticipateDetails] = useState({
        participant_addition_details: []
    } as any)
    const pageFlag = location.pathname == "/transactions/expo-booth-list" ? 'BOOTH' : 'TICKETS';

    const handleUpdate = (formData: any) => {

        const participantData = Object.keys(formData)
            .filter(key => key.startsWith('Delivery Address-'))
            .map(key => {
                const customerId = key.split('-')[1]; // Extract customer_id from the key

                return {
                    id: customerId,
                    value: formData[key]
                };
            });


        Object.keys(formData)
            .filter(key => key.startsWith('Delivery Address-'))
            .forEach(key => delete formData[key]);

        const data: any = {
            id: id,
            first_name: formData.first_name,
            last_name: formData.last_name,
            email_address: formData.email_address,
            phone_no: formData.phone_no,
            booth_no: formData.booth_no,
            participant_data: JSON.stringify(participantData), // Convert formData to JSON string
            pageFlag: pageFlag
        };
        setOldBooth(data.booth_no);
        const dataUpdate: any = {
            id: id,
            first_name: formData.first_name,
            last_name: formData.last_name,
            email_address: formData.email_address,
            phone_no: formData.phone_no,
            booth_no_old: oldBooth,
            booth_no_new: formData.booth_no,
            participant_data: JSON.stringify(participantData), // Convert formData to JSON string
            pageFlag: pageFlag
        };


        mutate(dataUpdate as any, { onSuccess: handleEditClose });
    }

    const handleEditClose = () => {
        setEditing(false);
    }

    const [tabLoading, setTabLoading] = useState(false)

    const initialparticipant = async () => {
        setTabLoading(true);
        try {
            const apiRes = await TransectionApiServices().getExpoBoothParticiPantDetails(`${id}`, `${pageFlag}`)
            setparticipateDetails(apiRes?.data)
            setTabLoading(false)
            form.setFieldsValue(apiRes?.data)
        } catch (error) {
            message.error("This is wrong")
        }
    }
    useEffect(() => {
        initialparticipant()
    }, [])



    return (

        <>
            {tabLoading ?
                <PageLoader />
                :


                <div>
                    <Form
                        id={formName}
                        name={formName}
                        form={form}
                        layout='vertical'
                        // initialValues={getInitialValues}
                        onFinish={handleUpdate}
                        onFinishFailed={() => setValidateTrigger(['onChange'])}
                        validateTrigger={validateTrigger}
                    >
                        <div className='parti_dtls'>
                            <div className='hed_ttl'>
                                <Breadcrumb separator="/" className='page_brdcrumb'>
                                    <Breadcrumb.Item className='text-decoration-none'>

                                        {location.pathname == '/transactions/expo-booth-list' ? <a href='/transactions/expo-booth-list'> Expo Booth List</a>
                                            : <a href='/transactions/tickets-list'> Ticket List</a>}



                                    </Breadcrumb.Item>
                                    <Breadcrumb.Item className='text-decoration-none'>Details</Breadcrumb.Item>
                                </Breadcrumb>
                            </div>
                            <FormSectionsSeparator title="">
                                <div className='button-group'>
                                    {editing ? (
                                        <>
                                            <Button onClick={() => setEditing(false)} style={{ marginRight: '10px' }}><CloseOutlined /> Cancel</Button>
                                            <Button loading={isLoading} htmlType='submit' className='btn' type='primary'><SaveOutlined /> Save</Button>
                                        </>
                                    ) : (
                                        <Button onClick={() => setEditing(true)} type='primary'><EditOutlined /> Edit </Button>
                                    )}
                                </div>
                            </FormSectionsSeparator>
                        </div>

                        <div className='partic_wrapp invoice_list'>
                            <Form.Item
                                name="event_name"
                                label="Event Name"
                                rules={[{ required: true, message: 'Please Enter your Event Name!' }]}
                            >
                                <Input disabled placeholder="Please Enter Event Name" />
                            </Form.Item>
                            <Form.Item
                                name="first_name"
                                label="First Name"
                                rules={[{ required: true, message: 'Please Enter your First Name!' }]}
                            >
                                <Input disabled={editing === false} placeholder="Please Enter your First Name" />
                            </Form.Item>
                            <Form.Item
                                name="last_name"
                                label="Last Name"
                                rules={[{ required: true, message: 'Please Enter your Last Name!' }]}
                            >
                                <Input disabled={editing === false} placeholder="Please Enter your Last Name" />
                            </Form.Item>
                            <Form.Item
                                name="email_address"
                                label="Email Address"
                                rules={[{ required: true, message: 'Please Enter your Email Address' }]}
                            >
                                <Input disabled={editing === false} placeholder="Please Enter your Email" />
                            </Form.Item>
                            <Form.Item
                                name="phone_no"
                                label="Phone No"
                                rules={[{ required: true, message: 'Please Enter your Phone No!' }]}
                            >
                                <Input disabled={editing === false} placeholder="Please Enter your Phone No" />
                            </Form.Item>

                            <Form.Item
                                name="booth_no"
                                label="Booth No"
                                rules={[{ required: true, message: 'Please Enter the Booth No!' }]}
                            >
                                <Input disabled placeholder="Please Enter the Booth No!" />
                            </Form.Item>

                        </div>
                        <div className='prti_form'>
                            <FormSectionsSeparator title="">
                                {participateDetails?.participant_addition_details.map((res: any, index: number) => {
                                    return (
                                        <BoothDetailField key={index} label={res.key_lable} value={res?.key_value} editing={editing} customer_id={res.customer_id} />
                                    )
                                })}
                            </FormSectionsSeparator>
                        </div>
                    </Form>
                </div>}
        </>

    );
};

const handleDownloadImg = (img: any) => {
    if (!img) return;
    const iframe = document.createElement('iframe');
    iframe.style.display = 'none';
    document.body.appendChild(iframe);

    const form = document.createElement('form');
    form.method = 'GET';
    form.action = img;

    iframe.appendChild(form);
    form.submit();

    iframe.onload = () => {
        document.body.removeChild(iframe);
        message.success('Image downloaded');
    };

}

const BoothDetailField: React.FC<BoothDetailFieldProps> = ({ label, value, customer_id }) => (
    <Form.Item className='w-100' label={
        <Tooltip title={label} className=''>
            <span className='truncate-label'>{label} </span>
            <span className='dwnld_icon'>{
                value.includes("https://suffixevnt.blob.core.windows.net/events/ExpoBoothEventRegistrationForm/image") &&
                <DownloadOutlined onClick={() => handleDownloadImg(value)} />}</span>
        </Tooltip>
    } name={`${label}-${customer_id}`}>
        {/* {editing ? ( */}
        <Input defaultValue={value} disabled />
        {/* ) : (
            <div className='in_value vale_name'><span>{value}</span></div>
        )} */}
    </Form.Item>
);

export default BoothParticipantDetailsPage;
